module.exports = __webpack_public_path__ + "media/images/placeholders/soon_ru-067800f08a23598f2a65c2e27b14c074.svg";